import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex h-screen bg-gray-50 overflow-hidden" data-id="element-337">
      {/* Fixed Sidebar */}
      <Sidebar data-id="element-338" />

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden" data-id="element-339">
        {/* Sticky Header */}
        <Header data-id="element-340" />

        {/* Scrollable content */}
        <main className="flex-1 overflow-y-auto" data-id="element-341">
          <div className="p-4 sm:p-6 lg:p-8" data-id="element-342">
            <div className="max-w-7xl mx-auto" data-id="element-343">{children}</div>
          </div>
        </main>
      </div>
    </div>;
}